export const environment = {
  name: 'dev' as 'dev' | 'prod',
  supabaseUrl: 'https://wuajbgxlvjwrhauijvwa.supabase.co',
  supabaseKey: 'sb_publishable_W0EUZN0LuFOWTfkq0pPq4g_1jiJe35k',
};